<template>
  <div
    v-if="
      (mergeRequestApprovedBy.approvedByRules &&
        mergeRequestApprovedBy.approvedByRules.length > 0) ||
      (applicationVersion !== 'onpremise' && getCodeOwners?.length > 0)
    "
    class="merge-request-approve-rules mb-3 border-bottom"
  >
    <gf-custom-collapse>
      <template #toggle>
        <div
          class="merge-request-approve-rules__button d-flex justify-content-between align-items-center font-weight-bolder p-2 px-3"
          @click.prevent="visible = !visible"
        >
          <div class="mr-3">
            <span class="d-flex align-items-center">
              <i class="gf-icon gf-icon-user-check mr-2"></i>
              {{ $t('approval_rules.title') }}
            </span>
            <!-- <b-icon-person-check-fill class="mr-2" />
            {{ $t('approval_rules.title') }} -->
          </div>
          <div>
            <span class="d-flex align-items-center">
              <i
                v-if="!visible"
                class="gf-icon gf-icon-chevron-down"
              ></i>
              <i
                v-else
                class="gf-icon gf-icon-chevron-up"
              ></i>
            </span>
            <!-- <b-icon-chevron-down v-if="!visible" />
            <b-icon-chevron-up v-else /> -->
          </div>
        </div>
      </template>
      <template #collapse>
        <div
          id="merge-request-rules"
          class="merge-request-rules"
        >
          <table class="table merge-request-rules__table mb-0">
            <tr>
              <th>{{ $t('approval_rules.table.h1') }}</th>
              <th><!--{{ $t('approval_rules.table.h2') }} --></th>
              <th>{{ $t('approval_rules.table.h3') }}</th>
              <th>{{ $t('approval_rules.table.h4') }}</th>
            </tr>
            <tr
              v-for="(rule, i) in mergeRequestApprovedBy.approvedByRules"
              :key="i"
            >
              <td>{{ rule.rule.name }}</td>
              <td>
                <div class="d-flex flex-wrap">
                  <user-label-item
                    v-for="user in rule.rule.allowedApprovers"
                    :key="'rules-block-user--' + user.username"
                    :user="user"
                    :has-user-link="true"
                    :show-name="false"
                    class="ml-1"
                    :tooltip-prefix="'rule-1-prefix-' + i + '--'"
                  />
                </div>
              </td>
              <td>
                {{ rule.approvalsCount }} {{ $t('approval_rules.table.of') }}
                {{ rule.rule.minimalApprovals }}
              </td>
              <td>
                <template v-if="rule.approvers && rule.approvers.length > 0">
                  <div class="d-flex flex-wrap">
                    <user-label-item
                      v-for="user in rule.approvers"
                      :key="'rules-block-approvers--' + user.username"
                      :user="user"
                      :has-user-link="true"
                      :show-name="false"
                      class="d-inline-block"
                      :tooltip-prefix="'rule-2-prefix-' + i + '--'"
                    />
                  </div>
                </template>
                <template v-else>{{ $t('approval_rules.table.not_approved') }}</template>
              </td>
            </tr>
            <tr v-if="applicationVersion !== 'onpremise' && getCodeOwners?.length > 0">
              <th colspan="4">Code Owners</th>
            </tr>
            <tr
              v-for="(item, i) in getCodeOwners"
              :key="item.pattern"
            >
              <td>
                <div class="text-secondary f6">
                  {{ item.section }}
                </div>
                <div>{{ item.pattern }}</div>
              </td>
              <td>
                <div class="d-flex">
                  <div
                    v-for="(owner, index) in item.owners"
                    :key="owner.username"
                    class="d-flex ml-1"
                  >
                    <user-label-item
                      :user="owner"
                      :has-user-link="true"
                      :show-name="false"
                      :tooltip-prefix="'rule-3-prefix-' + i + '-' + index"
                    />
                  </div>
                </div>
              </td>
              <td>{{ item.approved ? item.approver.length : 0 }} из 1</td>

              <td>
                <template v-if="item.approver && item.approver.length > 0">
                  <div class="d-flex flex-wrap">
                    <user-label-item
                      v-for="user in item.approver"
                      :key="'rules-block-approvers-11--' + user.username"
                      :user="user"
                      :has-user-link="true"
                      :show-name="false"
                      class="d-inline-block"
                      :tooltip-prefix="'rule-2-prefix---1231--' + user.id + '--'"
                    />
                  </div>
                </template>
                <template v-else>{{ $t('approval_rules.table.not_approved') }}</template>
              </td>
            </tr>
          </table>
        </div>
      </template>
    </gf-custom-collapse>
  </div>
</template>

<script>
import UserLabelItem from '@shared/shared-components/shared/user-label-item';
import MergeReqApproverS from '../merge-request-approver.service';
import GfCustomCollapse from '@/shared-modules/shared-components/shared/GfCustomCollapse.vue';

import langMessages from '../merge-request-approval.messages';
// import MergeRequestService from "@shared/services/merge-request.service";
// import store from "@/store";

export default {
  name: 'MergeRequestApproveRules',
  components: {
    UserLabelItem,
    GfCustomCollapse
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    mergeRequestApprovedBy() {
      return this.$store.getters.getMergeRequestApprovedBy;
    },
    getCodeOwners() {
      return this.$store.getters.getCodeOwners;
    },
    applicationVersion() {
      return this.$store.getters.getApplicationVersion;
    }
  },
  mounted() {
    MergeReqApproverS.getMergeRequestApprovedBy(
      this.$route.params.alias,
      this.$route.params.projectAlias,
      this.$route.params.id
    );
  },
  i18n: {
    messages: langMessages
  }
};
</script>

<style lang="scss" scoped>
.approvers-list {
  &:hover {
    > *:not(:first-child) {
      margin-left: 0;
    }
  }

  & > * {
    transition: all 0.3s ease;
    position: relative;
    top: 0;

    &:not(:first-child) {
      margin-left: -10px;
    }

    &:hover {
      z-index: 1;
      top: -4px;
    }
  }
}

td {
  vertical-align: middle;
}

.merge-request-approve-rules {
  border: 1px solid var(--border-color);
  border-radius: 0.25rem;

  &__button {
    cursor: pointer;
  }
}
</style>
